var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.item.key == 'dashboard' ||
    (_vm.item.key === 'doseSpot' &&
      _vm.systemSetting?.doseSpotEnable &&
      _vm.currentUser?.doseSpotId) ||
    (_vm.item.key == 'emar' &&
      _vm.isEMAREnabled &&
      _vm.currentUser?.emarId) ||
    (_vm.item.key !== 'doseSpot' &&
      _vm.item.key !== 'emar' &&
      _vm.hasCurrentUserPermission(_vm.item.key) &&
      (_vm.item.key != 'labs' || (_vm.systemSetting && _vm.systemSetting.labEnable)))
    && !_vm.isSidebarAvailableForProviders()
  )?_c('div',{staticClass:"sidebar-menu-item",class:_vm.selected ? 'selected' : '',style:(_vm.selected ? 'font-weight: bold' : 'filter: contrast(0.8)'),attrs:{"id":'sidebar-item-' + _vm.item.key},on:{"click":_vm.onSidebarItemClick}},[_c('img',{staticClass:"mr-1",attrs:{"height":"22","width":"22","src":require(`../../assets/icons/${_vm.item.icon}.svg`)}}),_vm._v(" "),_c('span',{staticClass:"no-wrap text-white ml-3"},[_vm._v(_vm._s(_vm.item.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }